import { Ripple } from "@/shared/ui/Ripple";

import { RealtimeFulfillmentList } from "@/app/elements/RealtimeFulfillmentList";
import { trans } from "@/app/localization/Trans";


export interface IFulfillmentPushNotificationPopupData {
    fulfillmentId: string;
    orderNumber: string;
    orderId: string;
    orderTime: Date;
    locationName: string;
    tableName: string;
}

export enum FulfillmentPushNotificationPopupAction {
    FulfillmentReady,
    FulfillmentScheduled
}

export class FulfillmentPushNotificationPopup {
    public static show(action: FulfillmentPushNotificationPopupAction, onClick: () => void, data: IFulfillmentPushNotificationPopupData, uniqueId?: string) {
        const parent = $(".app");
        if (uniqueId !== undefined) {
            if (parent.find(".popup." + uniqueId).length !== 0) return;
        }

        //dim background
        let dim = parent.find("> .dim.popupdim");
        if (dim.length === 0) dim = $('<div class="dim popupdim" />').appendTo(parent);
        else dim.stop(true, false);

        dim[0].offsetHeight;
        dim.addClass("shown");

        const msg = $('<div class="popup' + (uniqueId === undefined ? "" : " " + uniqueId) + '"></div>').appendTo(
            parent
        );
        const head = $('<div class="orderinfo" />').appendTo(msg);

        head.append('<div class="ordernumber">' + data.orderNumber + "</div>");
        msg.append(`<div class="usecase">${FulfillmentPushNotificationPopup.getMessage(action)}</div>`);

        const fulfillments = new RealtimeFulfillmentList(data.orderId, false, data.fulfillmentId).renderTo(msg);
        fulfillments.startListening();

        const btns = $('<div class="btns" />').appendTo(msg);
        this.addConfirmButton(
            btns,
            () => {
                onClick();
                fulfillments.stopListening();
            },
            trans.notification.onMyWay,
            false
        );

        msg[0].offsetHeight;
        msg.css("margin-top", (msg.height() + 60) / -2);
        msg.addClass("fulfillment");
        msg.addClass("shown");
    }
    
    private static getMessage(action: FulfillmentPushNotificationPopupAction) {
        let message = "";
        switch (action) {
            case FulfillmentPushNotificationPopupAction.FulfillmentReady:
                message = trans.notification.orderReadyToPickUp;
                break;
            case FulfillmentPushNotificationPopupAction.FulfillmentScheduled:
                message = trans.notification.orderScheduled;
                break;
        }
        return message;
    }

    private static addConfirmButton(
        buttonsContainer: JQuery,
        confirmHandler?: { () },
        confirmButton?: string,
        highlightConfirm?: boolean
    ) {
        Ripple.bind(
            $(
                '<button class="btn confirm ' +
                    (highlightConfirm !== undefined && highlightConfirm === true ? "orange" : "") +
                    '">' +
                    (confirmButton === undefined ? "Ok" : confirmButton) +
                    "</button>"
            )
                .appendTo(buttonsContainer)
                .click((e) => {
                    e.preventDefault();
                    confirmHandler!();
                    FulfillmentPushNotificationPopup.close($(e.currentTarget).parent().parent());
                })
        );
    }

    private static close($popup: JQuery) {
        $popup.addClass("closing")[0].offsetHeight;
        const totalPopups = $(".app > .popup").length;

        $popup
            .removeClass("shown")
            .delay(600)
            .queue((e) => {
                $popup.remove();
                e();
            });

        //check if dim needs to be removed
        if (totalPopups <= 1) {
            const dim = $(".app > .dim.popupdim")
                .delay(250)
                .queue((c) => {
                    dim.removeClass("shown")
                        .delay(350)
                        .queue((a) => {
                            dim.remove();
                            a();
                        });

                    c();
                });
        }
    }
}
